export const FETCH_INGREDIENT_SPECIAL_CASE = {
  START: 'START_FETCH_INGREDIENT_SPECIAL_CASE',
  COMPLETE: 'COMPLETE_FETCH_INGREDIENT_SPECIAL_CASE',
  FAIL: 'FAIL_FETCH_INGREDIENT_SPECIAL_CASE',
  CLEANUP: 'CLEANUP_FETCH_INGREDIENT_SPECIAL_CASE',
}

export const UPSERT_INGREDIENT_SPECIAL_CASE = {
  START: 'START_UPSERT_INGREDIENT_SPECIAL_CASE',
  COMPLETE: 'COMPLETE_UPSERT_INGREDIENT_SPECIAL_CASE',
  FAIL: 'FAIL_UPSERT_INGREDIENT_SPECIAL_CASE',
}
